import { render } from "./SimpleResetPasswordPage.vue?vue&type=template&id=adc7090c&scoped=true&ts=true"
import script from "./SimpleResetPasswordPage.vue?vue&type=script&lang=ts"
export * from "./SimpleResetPasswordPage.vue?vue&type=script&lang=ts"

import "./SimpleResetPasswordPage.vue?vue&type=style&index=0&id=adc7090c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adc7090c"]])

export default __exports__